<div id="not-found">
    <h1>404 - Not Found</h1><br>
    <h2>The requested resource has not been found.</h2>
</div>